import { Tag } from 'antd';
import React from 'react'

const RolePill = ({ role }) => {

    const roleMeta = {
        0: { label: 'Super Admin', color: 'gold' },
        1: { label: 'Admin', color: 'red' },
        2: { label: 'Manager', color: 'blue' },
        3: { label: 'Staff', color: 'green' },
    };

    const { label, color } = roleMeta[role] ?? { label: 'Unknown', color: 'gray' };

    return (
        <Tag color={color} style={{ fontSize: 10, fontWeight: 500, letterSpacing: '0.05em', }}>
            {label}
        </Tag>
    )
}

export default RolePill